"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseFullscreen = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var CloseFullscreen = function CloseFullscreen() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.833 0c.353 0 .64.283.64.632v6.315h6.388c.353 0 .639.283.639.632v1.263a.635.635 0 01-.639.632h-8.305a.635.635 0 01-.64-.632V.632c0-.35.287-.632.64-.632h1.277zM.5 15.158c0-.349.286-.632.639-.632h8.305a.637.637 0 01.64.632v8.21a.635.635 0 01-.64.632H8.167a.635.635 0 01-.64-.632v-6.315H1.14A.635.635 0 01.5 16.42v-1.263z",
    clipRule: "evenodd"
  });
};

exports.CloseFullscreen = CloseFullscreen;